import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigateService } from '@shared/services/navigate.service';
import { Config } from '@shared/configs/config';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'header-logo',
  templateUrl: './header-logo.component.html',
  styleUrls: ['./header-logo.component.scss'],
  standalone: true,
  imports: [TranslateModule]
})
export class HeaderLogoComponent implements OnInit {
  @ViewChild('el') el: ElementRef;

  Config = Config;

  constructor(public n: NavigateService) {}

  ngOnInit(): void {}
}
